import { createModule } from '../createModule';
import { IAgreementType } from '@/models';

export const agreementType = createModule<IAgreementType>('agreementType', {
    url: 'agreement_type',
});